var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.policy)?_c('div',{staticClass:"small-12 articleTitle flex justify-center animated fadeIn"},[_c('h1',[_vm._v(_vm._s(_vm.policy.attributes.title))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }